export default function hasInlineTextrule(block) {
  return block &&
    block.hasIn(["data", "inline_textrules"]) &&
    block.getIn(["data", "inline_textrules"]) &&
    block.getIn(["data", "inline_textrules"]).length > 0;
}
